import React from 'react';

interface RatingDistributionBarProps {
  label: string;
  count: number;
  total: number;
  colorClass?: string;
}

export const RatingDistributionBar: React.FC<RatingDistributionBarProps> = ({
  label,
  count,
  total,
  colorClass = 'bg-[#cfef00]'
}) => {
  if (total === 0 || count === 0) return null;

  const percentage = Math.round((count / total) * 100);

  return (
    <div className="flex items-center gap-2 text-sm mb-1.5">
      <div className="w-28 shrink-0 truncate text-muted-foreground">{label}</div>
      <div className="flex-1 bg-muted rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all duration-300 ${colorClass}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="w-10 text-right font-mono text-foreground text-xs">{percentage}%</div>
    </div>
  );
};
